<button [matMenuTriggerFor]="paymentMenu"
        class="absolute-more-btn on-hover"
        mat-icon-button>
    <mat-icon class="add-blue">more_horiz</mat-icon>
</button>

<mat-menu #paymentMenu="matMenu">
    <button (click)="showPaymentDetail()" mat-menu-item>
        Details
    </button>
    <button (click)="sendReceipts()" *ngIf="hasWriteAccess"
            mat-menu-item>
        Send Receipt
    </button>
    <button (click)="editPayment()" *ngIf="paymentGroup.processor === 'offline' && paymentGroup.hasValidPayments && hasWriteAccess" mat-menu-item>
        Edit
    </button>
    <!-- Online Payments -->
    <button (click)="deletePayment()"
            *ngIf="jwt && jwt.superUser && paymentGroup.processor !== 'offline' && paymentGroup.hasValidPayments"
            mat-menu-item>
        Delete
        <app-super-star></app-super-star>
    </button>
    <!-- Offline Payments -->
    <button (click)="deleteOfflinePaymentGroup();"
            *ngIf="paymentGroup.processor === 'offline' && paymentGroup.hasValidPayments && hasWriteAccess"
            mat-menu-item>
        Delete
    </button>
    <button (click)="refundPayment()"
            *ngIf="jwt && jwt.superUser && paymentGroup.processor !== 'offline' && paymentGroup.hasValidPayments"
            mat-menu-item>
        Refund
        <app-super-star></app-super-star>
    </button>
    <button (click)="archivePayment();"
            *ngIf="jwt && jwt.superUser && !paymentGroup.hasValidPayments && paymentGroup.processor === 'offline'"
            mat-menu-item>
        Archive
        <app-super-star></app-super-star>
    </button>
    <button (click)="showPaymentHistory()"
            *ngIf="jwt && jwt.superUser" mat-menu-item>
        History
        <app-super-star></app-super-star>
    </button>
</mat-menu>
